import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { LoadChainageDto } from 'src/app/server-api/models';
import { LoadChainageControllerService } from 'src/app/server-api/services';
import { DropdownComponent } from 'src/app/utils-flc/dropdown/dropdown.component';

@Component({
  selector: 'app-load-chainage-dropdown',
  templateUrl: './load-chainage-dropdown.component.html',
  styleUrls: ['./load-chainage-dropdown.component.css']
})
export class LoadChainageDropdownComponent extends DropdownComponent {

  constructor(private loadService: LoadChainageControllerService,
    public override translate: TranslateService,
    public override fb: FormBuilder
    ) {
    super(translate, fb);
  }

  override ngOnInit(): void {

    this.placeholderText = 'load-chainage-dropdown.choose';

    super.ngOnInit();
  }

  override getItems(): void {

    super.getItems();
    this.loadService.getLoadChainages({ sort: ['chainage'], size:999 }).subscribe(
      value  => {
        this.items = value['content'] as LoadChainageDto[];
        this.setPreSelect(this.preSelect);
      }
      ,
      error => console.error(JSON.stringify(error)),
      
      );
  }

 
}
